
import React from "react";
import { Schemes } from "../utils";
import Header from "./shared/Header";
import Footer from "./shared/Footer";
import { i18nManager } from "../i18n";
import Contact from "./shared/Contact";
import { Button } from "@ronuse/noseur";
import * as ReactRouterDom from "react-router-dom";

function NotFound() {
    const navigate = ReactRouterDom.useNavigate();
    const { platform } = ReactRouterDom.useParams();
    const labels = i18nManager.Labels.search_and_404;

    return (<div className="support">
        <Header />
        <div className="not-found">
            <svg width="714" height="404" viewBox="0 0 714 404" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10V163.6C10 173.784 14.0621 183.552 21.2927 190.753C28.5232 197.954 38.33 202 48.5556 202H164.222M164.222 10V394M549.778 10V163.6C549.778 173.784 553.84 183.552 561.07 190.753C568.301 197.954 578.108 202 588.333 202H704M704 10V394M279.889 48.4V355.6C279.889 365.784 283.951 375.552 291.182 382.753C298.412 389.954 308.219 394 318.444 394H395.556C405.781 394 415.588 389.954 422.818 382.753C430.049 375.552 434.111 365.784 434.111 355.6V48.4C434.111 38.2157 430.049 28.4485 422.818 21.2471C415.588 14.0457 405.781 10 395.556 10H318.444C308.219 10 298.412 14.0457 291.182 21.2471C283.951 28.4485 279.889 38.2157 279.889 48.4Z" stroke="#D9D9D9" stroke-opacity="0.74" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div className="info">
                <span>{labels.page_not_exist}</span>
                <div>
                    <Button scheme={Schemes.RIVTN_HERA} link={`/${platform}`} text={labels.go_to_homepage} />
                    <Button scheme={Schemes.RIVTN_HERA} text={labels.previous_page} onClick={() => navigate(-1)} outlined />
                </div>
            </div>
        </div>
        <Contact />
        <Footer />
    </div>);
}

export default NotFound;
